import { LIVE_TYPE, INTERNET_TYPE } from './../consts';

export const auctionsCatalog = state => (state.auctionsCatalog);
export const artworks = state => (state.artworks);
export const auctions = (state) => {
  const catalog = state.auctionsCatalog;
  if (catalog.auctionType === LIVE_TYPE) {
    return catalog.liveAuctions;
  }
  if (catalog.auctionType === INTERNET_TYPE) {
    return catalog.internetAuctions;
  }
  return catalog.hammerAuctions;
};
export const meta = state => state.meta;
export const findAuction = (state, getters) => (id) => {
  const artwork = getters.findArtwork(id);
  if (getters.auctionsCatalog.auctionType === LIVE_TYPE) {
    return artwork.liveAuction;
  }
  if (getters.auctionsCatalog.auctionType === INTERNET_TYPE) {
    return artwork.internetAuction;
  }
  return artwork.hammerAuction;
};
export const findArtwork = (state, getters) => (id) => {
  const allArtworks = getters.artworks;
  return allArtworks.find(artwork => artwork.id === id);
};



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/store/getters.js